<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: '80Mesh',

    metaInfo: { title: '80Mesh' },

    extends: View,

    mixins: [
      LoadSections([
        'hero-alt',
        'Producto80Mesh',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: '80Mesh',
      },
    },
  }
</script>
